<div
  class="select-none fixed w-full h-full left-0 top-0 right-0 bottom-0 bg-black/50 z-50 flex items-center justify-center p-4"
>
  <div
    class="bg-white rounded-lg shadow-2xl w-full max-w-2xl max-h-[90vh] min-h-100 overflow-hidden flex flex-col"
  >
    <!-- Header -->
    <div class="border-b border-gray-200 px-6 py-4">
      <h1 class="text-xl font-bold text-gray-900">
        {{ 'user_preferences.title' | translate }}
      </h1>
    </div>

    <!-- Content: two-column layout with vertical tabs -->
    <div class="flex-1 overflow-hidden flex flex-col md:flex-row">
      <!-- Tabs (left) -->
      <aside class="w-full md:w-50 border-r border-gray-200 bg-gray-50 p-4 overflow-y-auto">
        <!-- Use Angular change handlers to notify TS of tab changes -->
        <input
          (change)="setActiveTab('language')"
          [checked]="activeTab === 'language'"
          class="hidden"
          id="tab-language"
          name="settings-tab"
          type="radio"
        />
        <input
          (change)="setActiveTab('accessibility')"
          [checked]="activeTab === 'accessibility'"
          class="hidden"
          id="tab-accessibility"
          name="settings-tab"
          type="radio"
        />

        <nav class="flex md:flex-col space-x-2 md:space-x-0 md:space-y-2">
          <label
            [class.bg-white]="activeTab === 'language'"
            [class.border-blue-600]="activeTab === 'language'"
            class="flex items-center p-3 rounded-lg cursor-pointer hover:bg-gray-100 transition border border-transparent w-full md:w-auto"
            for="tab-language"
          >
            <svg
              class="size-5"
              fill="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clip-rule="evenodd"
                d="M9 2.25a.75.75 0 0 1 .75.75v1.506a49.384 49.384 0 0 1 5.343.371.75.75 0 1 1-.186 1.489c-.66-.083-1.323-.151-1.99-.206a18.67 18.67 0 0 1-2.97 6.323c.318.384.65.753 1 1.107a.75.75 0 0 1-1.07 1.052A18.902 18.902 0 0 1 9 13.687a18.823 18.823 0 0 1-5.656 4.482.75.75 0 0 1-.688-1.333 17.323 17.323 0 0 0 5.396-4.353A18.72 18.72 0 0 1 5.89 8.598a.75.75 0 0 1 1.388-.568A17.21 17.21 0 0 0 9 11.224a17.168 17.168 0 0 0 2.391-5.165 48.04 48.04 0 0 0-8.298.307.75.75 0 0 1-.186-1.489 49.159 49.159 0 0 1 5.343-.371V3A.75.75 0 0 1 9 2.25ZM15.75 9a.75.75 0 0 1 .68.433l5.25 11.25a.75.75 0 1 1-1.36.634l-1.198-2.567h-6.744l-1.198 2.567a.75.75 0 0 1-1.36-.634l5.25-11.25A.75.75 0 0 1 15.75 9Zm-2.672 8.25h5.344l-2.672-5.726-2.672 5.726Z"
                fill-rule="evenodd"
              />
            </svg>

            <span class="ml-2 text-gray-900 font-medium">{{
              'user_preferences.language_tab' | translate
            }}</span>
          </label>

          <label
            [class.bg-white]="activeTab === 'accessibility'"
            [class.border-blue-600]="activeTab === 'accessibility'"
            class="flex items-center p-3 rounded-lg cursor-pointer hover:bg-gray-100 transition border border-transparent w-full md:w-auto"
            for="tab-accessibility"
          >
            <svg
              class="size-5"
              fill="currentColor"
              overflow="visible"
              viewBox="0 0 483.2226563 551.4306641"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clip-rule="evenodd"
                d="M161.9882813,98.1240234  c24.9628906-2.3046875,44.3574219-23.8110352,44.3574219-48.9658203C206.3457031,22.0830078,184.2626953,0,157.1875,0  s-49.1572266,22.0830078-49.1572266,49.1582031c0,8.2568359,2.3037109,16.7055664,6.1445313,23.8105469l17.515625,246.4667969  l180.3964844,0.0488281l73.9912109,173.3652344l97.1445313-38.0976563l-15.0429688-35.8203125l-54.3662109,19.625  l-71.5908203-165.2802734l-167.7294922,1.1269531l-2.3027344-31.2128906l121.4228516,0.0483398v-46.1831055l-126.0546875-0.0493164  L161.9882813,98.1240234z"
                fill="currentColor"
                fill-rule="evenodd"
              />
              <path
                clip-rule="evenodd"
                d="M343.4199219,451.5908203  c-30.4472656,60.1875-94.1748047,99.8398438-162.1503906,99.8398438C81.4296875,551.4306641,0,470.0009766,0,370.1611328  c0-70.1005859,42.4853516-135.2436523,105.8818359-164.1210938l4.1025391,53.5375977  c-37.4970703,23.628418-60.6123047,66.262207-60.6123047,110.9506836c0,72.4267578,59.0712891,131.4970703,131.4970703,131.4970703  c66.2617188,0,122.7646484-50.8515625,130.4697266-116.0869141L343.4199219,451.5908203z"
                fill="currentColor"
                fill-rule="evenodd"
              />
            </svg>
            <span class="ml-2 text-gray-900 font-medium">{{
              'user_preferences.accessibility_tab' | translate
            }}</span>
          </label>
        </nav>
      </aside>

      <!-- Panels (right) -->
      <section class="flex-1 overflow-y-auto p-6">
        @switch (this.activeTab) {
          @case ('language') {
            <!-- Language Panel -->
            <div class="tab-panel tab-lang">
              <h2 class="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-4">
                {{ 'user_preferences.language' | translate }}
              </h2>
              <div class="space-y-3">
                <!-- Sélecteurs visuels avec drapeaux -->
                <div class="flex items-center gap-3">
                  <label
                    class="flex items-center p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition w-full md:w-auto justify-center space-x-3"
                    [class.bg-vert-1]="currentPreferences.language === 'fr'"
                    [class.text-white]="currentPreferences.language === 'fr'"
                  >
                    <input
                      type="radio"
                      name="language"
                      value="fr"
                      class="hidden"
                      (change)="onLanguageChange('fr')"
                      [attr.checked]="currentPreferences.language === 'fr' ? true : null"
                    />
                    <img
                      ngSrc="/assets/images/flags/fr.svg"
                      class="rounded"
                      alt="French Flag"
                      width="48"
                      height="28"
                    />
                    <span class="ml-1 font-medium">{{
                      'user_preferences.french' | translate
                    }}</span>
                  </label>

                  <label
                    class="flex items-center p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition w-full md:w-auto justify-center space-x-3"
                    [class.bg-vert-1]="currentPreferences.language === 'en'"
                    [class.text-white]="currentPreferences.language === 'en'"
                  >
                    <input
                      type="radio"
                      name="language"
                      value="en"
                      class="hidden"
                      (change)="onLanguageChange('en')"
                      [attr.checked]="currentPreferences.language === 'en' ? true : null"
                    />
                    <img
                      ngSrc="/assets/images/flags/en.svg"
                      class="rounded"
                      alt="English Flag"
                      width="64"
                      height="33"
                    />
                    <span class="ml-1 font-medium">{{
                      'user_preferences.english' | translate
                    }}</span>
                  </label>
                </div>
              </div>
            </div>
          }
          @case ('accessibility') {
            <!-- Accessibility Panel -->
            <div class="tab-panel tab-acc">
              <h2 class="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-4">
                {{ 'user_preferences.accessibility' | translate }}
              </h2>
              <div class="space-y-4">
                <div
                  class="flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition"
                >
                  <label class="flex items-center cursor-pointer flex-1" for="boldText-checkbox">
                    <span class="text-gray-900 font-medium">{{
                      'user_preferences.bold_text' | translate
                    }}</span>
                  </label>
                  <input
                    id="boldText-checkbox"
                    type="checkbox"
                    class="w-5 h-5 text-blue-600 rounded cursor-pointer"
                    (change)="onBoldTextChange($event)"
                    [attr.checked]="currentPreferences.boldText ? true : null"
                  />
                </div>

                <div
                  class="flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition"
                >
                  <label
                    class="flex items-center cursor-pointer flex-1"
                    for="uppercaseText-checkbox"
                  >
                    <span class="text-gray-900 font-medium">{{
                      'user_preferences.uppercase_text' | translate
                    }}</span>
                  </label>
                  <input
                    id="uppercaseText-checkbox"
                    type="checkbox"
                    class="w-5 h-5 text-blue-600 rounded cursor-pointer"
                    (change)="onUppercaseTextChange($event)"
                    [attr.checked]="currentPreferences.uppercaseText ? true : null"
                  />
                </div>

                <div
                  class="flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition"
                >
                  <label
                    class="flex items-center cursor-pointer flex-1"
                    for="dyslexicMode-checkbox"
                  >
                    <span class="text-gray-900 font-medium">{{
                      'user_preferences.dyslexic_mode' | translate
                    }}</span>
                  </label>
                  <input
                    id="dyslexicMode-checkbox"
                    type="checkbox"
                    class="w-5 h-5 text-blue-600 rounded cursor-pointer"
                    (change)="onDyslexicModeChange($event)"
                    [attr.checked]="currentPreferences.dyslexicMode ? true : null"
                  />
                </div>
              </div>
            </div>
          }
        }
      </section>
    </div>

    <!-- Footer -->
    <div class="border-t border-gray-200 px-6 py-4 flex flex-col md:flex-row gap-3">
      <button
        (click)="this.onCancel()"
        class="w-full md:flex-1 px-4 py-2 h-[58px] bg-gray-100 text-gray-900 font-medium rounded-lg hover:bg-gray-200 transition cursor-pointer"
      >
        {{ 'common.cancel' | translate }}
      </button>
      <button
        (click)="this.savePreferences()"
        class="w-full md:flex-1 px-4 py-2 h-[58px] bg-vert-1 text-white font-medium rounded-lg hover:bg-vert-2 transition cursor-pointer"
      >
        {{ 'common.save' | translate }}
      </button>
    </div>
  </div>
</div>
